export enum ScheduledLessonFilterEnum {
  ALL_SCHEDULED_LESSONS = 'ALL_SCHEDULED_LESSONS',
  COMPLETED_SCHEDULED_LESSONS = 'COMPLETED_SCHEDULED_LESSONS',
  ONLY_SCHEDULED_LESSONS = 'ONLY_SCHEDULED_LESSONS',
  PENDING_SCHEDULED_LESSONS = 'PENDING_SCHEDULED_LESSONS',
}
